/* Baby Rascals product page: accessible, smooth accordions.
   .brp-ac--mob = collapsible on phones only (always open on wider screens); .brp-ac--all = collapsible everywhere. */
(function () {
  if (window.__brpAcc) return; window.__brpAcc = true;
  var mq = window.matchMedia('(max-width: 749.5px)');
  function init(root) {
    var btn = root.querySelector('.brp-ac__btn'), panel = root.querySelector('.brp-ac__panel'); if (!btn || !panel) return;
    var always = root.classList.contains('brp-ac--all');
    function active() { return always || mq.matches; }
    function sync() {
      if (active()) { btn.removeAttribute('tabindex'); btn.setAttribute('aria-expanded', root.classList.contains('is-open') ? 'true' : 'false'); }
      else { btn.setAttribute('tabindex', '-1'); btn.removeAttribute('aria-expanded'); }
    }
    btn.addEventListener('click', function () {
      if (!active()) return;
      var open = !root.classList.contains('is-open');
      root.classList.toggle('is-open', open); btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    (mq.addEventListener ? mq.addEventListener('change', sync) : mq.addListener(sync)); sync();
  }
  function all() { document.querySelectorAll('[data-brp-ac]').forEach(function (r) { if (!r.__brp) { r.__brp = 1; init(r); } }); }
  all(); document.addEventListener('shopify:section:load', all);
})();
